module.exports = __webpack_public_path__ + "static/media/headerIcons.fb11131f.svg";